// Whether a plugin component is listed (and togglable) on an instance and counted in badge views.
// A custom action with an empty `contexts` list is only ever dispatched programmatically, so it
// isn't user-facing; `["NONE"]` is a real gear-menu context and stays visible.
export const isUserVisibleComponent = (component: {
  type?: string;
  contexts?: unknown[];
}): boolean => {
  if (
    component.type === "internal_processor_config" ||
    component.type === "list_input_config"
  ) {
    return false;
  }
  return !(
    component.type === "custom_action_config" &&
    Array.isArray(component.contexts) &&
    component.contexts.length === 0
  );
};
